import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { usePicture, useText } from 'hooks';
import { MOBILE, TABLET } from 'helpers/styles/media';

const BottomLine = () => {
  return (
    <BottomLineBlock>
      <BottomLineWrapper>
        <Container>
          <BottomImg>
            {usePicture([
              'bottom-img-m.png',
              'bottom-img-d.png',
              'bottom-img-d.png',
            ])}
          </BottomImg>
        </Container>
        <Text>{useText('bottomLine__text', true)}</Text>
      </BottomLineWrapper>
    </BottomLineBlock>
  );
};

const BottomLineBlock = styled.div`
  background: #fff;

  @media ${TABLET} {
    overflow: hidden;
  }

  @media ${MOBILE} {
    padding: 0;
  }
`;

const BottomLineWrapper = styled.div`
  background: #ffffff;
`;

const BottomImg = styled.div`
  max-width: 843px;
  margin: 0 auto;

  @media ${TABLET} {
    width: 748px;
  }
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 11px;
  line-height: 34px;
  text-align: center;
  color: #303030;
  margin: 0 auto;
  background-color: #000000;
`;

export default BottomLine;
